<h1 class="cg-h1">{{ (routeData$ | async)?.title || pageTitle }}</h1>

<section>
  <div class="cg-flex-vertical-center">
    <div>
      <cigna-icon type="exclamation-triangle" class="alert-icon"></cigna-icon>
    </div>
    <div class="message">
      You have chosen a function that has not yet been added to our beta site.
      All of the capabilities can still be accessed on the
      <a href="/web/secure/chcp/windowmanager">original CignaforHCP.com</a>
      site.
    </div>
  </div>
</section>
